import { useEffect } from "react";
import { usePresentationConfig } from "../queries/usePresentationConfig";

// Dynamic <title>: "<page> · <suffix>" — suffix defaults to the branding
// title resolved from `ir.config` (`presentation.app_title`), but the
// workspace passes the active organization name when present so the tab
// reads "<page> · <org>". Falls back to "EDE Workspace" while the config
// query is still loading.
export function useDocumentTitle(title?: string | null, suffix?: string | null): void {
    const { data: branding } = usePresentationConfig();
    const appName = branding?.title || "EDE Workspace";
    useEffect(() => {
        const tail = suffix || appName;
        document.title = title ? `${title} · ${tail}` : tail;
    }, [title, suffix, appName]);
}
